import React from "react";
import { getTenant } from "../lib/tenant";
import Landing from "../pages/Landing";
import TradeHome from "../pages/TradeHome";
import SportsHome from "../pages/SportsHome";
import CyberHome from "../pages/CyberHome";
import CyberOpsSaHome from "../pages/CyberOpsSaHome";

export default function TenantHome() {
    const tenant = getTenant();
    if (tenant.id === "trade") return <TradeHome />;
    if (tenant.id === "sports") return <SportsHome />;
    if (tenant.id === "cyberops") return <CyberHome />;
    if (tenant.id === "cyberopssa") return <CyberOpsSaHome />;
    return <Landing />;
}
